module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/mask/3-c133ee3062de370a37b093e9e7b4342b.jpg";